import React from 'react';
import { QueueComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';

const QueueComponent = ({ uiComponent }: UiComponentElementInterface<QueueComponentInterface>) => {
  return (
    <div
      className={`w-full`}
      style={{
        color: uiComponent?.styling?.textColor || '#000',
      }}>
      <div className="h-12 w-full relative text-white font-bold grid justify-items-center transition-all">
        <EmptyComponent componentName="Queue Component" />
      </div>
    </div>
  );
};

export default QueueComponent;
